<template>
  <div class="view--news">
    <loader v-if="loader"></loader>

    <header class="header" v-if="!inApp">
      <div class="containter">
        <div class="row justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <nav class="nav">
              <div class="back" @click="goBack()">
                <i class="material-icons icon">chevron_left</i>
              </div>
              <h1 class="title">{{ brand.name }}</h1>
            </nav>
          </div>
        </div>
      </div>
    </header>

    <main :class="{ 'in-app': inApp }" v-cloak>
      <div class="containter">
        <div class="row no-gutters justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <div class="image" v-if="image">
              <a v-if="video" :href="video" target="_blank" class="video-link">
                <img :src="image" :alt="title">
                <div class="fig__video">
                  <img src="../../../assets/img/play-icon.svg" alt="play-icon">
                </div>
              </a>
              <img v-else :src="image" :alt="title">
            </div>
            <div class="meta">
              <div class="title">{{ title }}</div>
              <div class="timestamp">{{ timestamp | moment('l LT') }}</div>
            </div>
            <vue-markdown
              class="content"
              :source="content"
              :anchor-attributes="{ target: '_blank', rel: 'nofollow' }"
              v-on:click.native="captureLink"
            ></vue-markdown>
            <div class="like-button">
              <div class="row no-gutters align-items-center" :class="{ like: liked }" @click.stop.prevent="toggleLike()">
                <i class="material-icons icon">{{ liked ? 'favorite' : 'favorite_border' }}</i>
                <span class="count">{{ likes }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import swal from 'sweetalert2';
import { mapState, mapMutations, mapGetters } from 'vuex';

import Loader from '@/components/Loader.vue';
import Axios from '@/helpers/axios';

export default {
  name: 'News',
  data() {
    return {
      title: '',
      timestamp: new Date(),
      content: '',
      image: '',
      brand: {
        name: '',
        image: '',
      },
      likes: 0,
      liked: false,
      video: null,
      webShareAPI: navigator.share,
    };
  },
  computed: {
    ...mapState([
      'loader',
      'client',
      'user',
    ]),
    ...mapGetters([
      'inApp',
    ]),
  },
  methods: {
    ...mapMutations([
      'setLoader',
    ]),
    captureLink(event) {
      if (event.target.tagName === 'A' && event.target.href.includes('@follow')) {
        event.preventDefault();
        const windowURL = new URL(window.location.href);
        const linkURL = new URL(event.target.href.replace('@follow', ''));
        windowURL.searchParams.forEach((value, key) => {
          linkURL.searchParams.append(key, value);
        });
        window.location.href = linkURL.href;
      }
    },
    ShareViaWebShareAPI() {
      navigator.share({
        text: this.title,
        url: window.location.href,
      });
    },
    toggleLike() {
      if (!this.user || !this.user.cell) return;

      const previousLiked = this.liked;
      const previousLikes = this.likes;

      const apiUrl = previousLiked ? '/v2/News/DislikeNews' : '/v2/News/LikeNews';
      const data = {
        p: this.client.phoneType,
        brand_id: this.$route.params.brand,
        dtk: this.client.dtk,
        newsId: this.$route.params.token,
      };

      this.liked = !previousLiked;
      this.likes = this.liked ? previousLikes + 1 : previousLikes - 1;

      Axios({
        method: 'post',
        url: apiUrl,
        data,
      })
        .then((response) => {
          if (response.data && response.data.code !== 500) {
            this.liked = previousLiked;
            this.likes = previousLikes;
            swal.fire({
              text: (response.data && response.data.msg) || '',
              confirmButtonText: this.$i18n.t('common.ok'),
              showCancelButton: false,
            });
          }
        })
        .catch(() => {
          this.liked = previousLiked;
          this.likes = previousLikes;
          swal.fire({
            text: this.$i18n.t('common.error'),
            confirmButtonText: this.$i18n.t('common.ok'),
            showCancelButton: false,
          });
        });
    },
    goBack() {
      if (window.history.length === 1) {
        this.$router.push({ name: 'Index' });
      } else {
        this.$router.back();
      }
    },
  },
  components: {
    Loader,
    VueMarkdown,
  },
  mounted() {
    this.setLoader(true);

    const data = {
      ...this.$route.query,
      p: this.client.phoneType,
      newsId: this.$route.params.token,
    };

    Axios({
      method: 'post',
      url: '/v2/News/GetNews',
      data,
    })
      .then((response) => {
        if (response.data && response.data.code === 500) {
          this.brand.name = response.data.data.name;
          this.title = response.data.data.title;
          this.timestamp = response.data.data.publishTime;
          this.content = response.data.data.content;
          this.image = response.data.data.image;
          this.likes = response.data.data.likes;
          this.liked = response.data.data.liked;
          this.video = response.data.data.video;

          document.title = `${this.brand.name} - ${this.title}`;
        } else {
          swal.fire({
            text: (response.data && response.data.msg) || '',
            confirmButtonText: this.$i18n.t('common.ok'),
            showCancelButton: false,
          });
        }
      })
      .catch(() => {
        swal.fire({
          text: this.$i18n.t('common.error'),
          confirmButtonText: this.$i18n.t('common.ok'),
          showCancelButton: false,
        });
      })
      .finally(() => {
        this.setLoader(false);
      });
  },
};
</script>

<style lang="sass" scoped>
$cb: cubic-bezier(.4, 0, .2, 1)

.view--coupon
  width: 100%
  height: 100%
  position: relative

  color: white

.header
  position: fixed
  top: 0
  right: 0
  left: 0
  padding: 12px
  z-index: 1020

  background-color: black

  color: white

  .nav
    display: flex

  .back
    height: 24px
    float: left

    cursor: pointer

    .icon
      width: 36px
      height: 36px

      font-size: 2.25rem
      line-height: 1

  .title
    flex-grow: 1
    margin: 3px 0

    text-shadow: 0 1px 2px rgba(0, 0, 0, .5)
    font-size: 1.2081rem
    font-weight: bold
    text-align: center
    line-height: 28px

  .placeholder
    width: 36px

  .btn
    padding: 0
    height: 34px
    background: transparent

    color: rgba(255, 255, 255, .75)

    vertical-align: middle
    line-height: 34px

    outline: 0

    &:active
      color: rgba(255, 255, 255, .25)

  .material-icons
    margin-right: 4px
    vertical-align: middle

main
  padding: 58px 0 80px

  &.in-app
    padding: 0 0 80px

.image
  background-color: #F5F5F5
  position: relative

  img
    width: 100%
    height: auto

.video-link
  display: block
  cursor: pointer

.fig__video
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  border-radius: 50%
  background: rgba(51, 51, 51, 0.3)

.meta
  padding: 24px 16px

  text-align: center

.title
  font-size: 1.125em
  font-weight: bold

.timestamp
  font-size: 0.875rem
  color: #8E8E8E

.content
  padding: 0 16px

  font-size: 14px
  color: #666

  ::v-deep img
    max-width: 100%
    height: auto

  ::v-deep a
    text-decoration: underline
    color: #2979FF

  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3,
  ::v-deep h4
    font-weight: bold
    color: #333

  ::v-deep h1
    font-size: 1.331rem

  ::v-deep h2
    font-size: 1.2081rem

  ::v-deep h3
    font-size: 1.125em

  ::v-deep h4
    font-size: 1rem

  ::v-deep strong
    color: #333

  ::v-deep ol ol,
  ::v-deep ol ul,
  ::v-deep ul ol,
  ::v-deep ul ul
    margin-left: -1rem

  ::v-deep blockquote
    margin: 1rem
    background-color: rgba(0, 0, 0, .05)
    padding: 16px

    border-radius: 12px

    p:last-child
      margin-bottom: 0

.like-button
  padding: 0 16px
  cursor: pointer
  color: #bdbdbd
  font-weight: 600;
  font-size: 14px;
  .icon
    font-size: 24px
    vertical-align: middle
    margin-right: 6px

  .like
    .icon,
    .count
      color: #e53935
</style>
